import React from 'react';

const microbeData = [
  { name: 'Escherichia coli', ThermalTolerance: 7, pHTolerance: 6, Motility: 5, trait: 'Aerobic' },
  { name: 'Bacillus subtilis', ThermalTolerance: 8, pHTolerance: 7, Motility: 6, trait: 'Aerobic' },
  { name: 'Pseudomonas aeruginosa', ThermalTolerance: 9, pHTolerance: 5, Motility: 4, trait: 'Aerobic' },
  { name: 'Clostridium difficile', ThermalTolerance: 7, pHTolerance: 6, Motility: 4, trait: 'Anaerobic' },
  { name: 'Staphylococcus aureus', ThermalTolerance: 9, pHTolerance: 8, Motility: 7, trait: 'Gram+' },
  { name: 'Lactobacillus acidophilus', ThermalTolerance: 5, pHTolerance: 6, Motility: 5, trait: 'Gram-' },
  { name: 'Streptococcus pyogenes', ThermalTolerance: 6, pHTolerance: 4, Motility: 4, trait: 'Gram+' },
  { name: 'Helicobacter pylori', ThermalTolerance: 8, pHTolerance: 7, Motility: 2, trait: 'Gram-' },
  { name: 'Mycobacterium tuberculosis', ThermalTolerance: 7, pHTolerance: 6, Motility: 5, trait: 'Anaerobic' },
  { name: 'Vibrio cholerae', ThermalTolerance: 10, pHTolerance: 8, Motility: 3, trait: 'Gram-' },
];

const traitColors = {
  'Aerobic': '#60A5FA',
  'Anaerobic': '#F87171',
  'Gram+': '#A3E635',
  'Gram-': '#a78bfa',
};

const traitIcons = {
  'Aerobic': '🫁',
  'Anaerobic': '🦠',
  'Gram+': '🔵',
  'Gram-': '🟣',
};

const attrIcons = {
  ThermalTolerance: '🌡️',
  pHTolerance: '🧪',
  Motility: '🏊',
};

function MicrobeCard({ name, ThermalTolerance, pHTolerance, Motility, trait }) {
  return (
    <div className="microbe-card flex flex-col items-center rounded-2xl bg-white shadow-md p-4 w-full sm:w-[calc(100%-16px)] md:w-56 min-h-[320px] border border-gray-100 relative">
      {/* Image placeholder */}
      <div className="w-16 h-16 rounded-full flex items-center justify-center mb-2 mt-2" style={{ background: traitColors[trait] + '22' }}>
        <span style={{ fontSize: 36 }}>{traitIcons[trait]}</span>
      </div>
      <div className="font-semibold text-base text-gray-800 mb-2 text-center">{name}</div>
      <div className="text-xs text-gray-400 mb-1">Attributes</div>
      <div className="flex flex-col gap-2 w-full mb-3">
        <div className="flex items-center justify-between w-full px-2">
          <span className="flex items-center gap-1 text-gray-600"><span>{attrIcons.ThermalTolerance}</span>ThermalTolerance</span>
          <span className="font-bold text-gray-800">{ThermalTolerance}</span>
        </div>
        <div className="flex items-center justify-between w-full px-2">
          <span className="flex items-center gap-1 text-gray-600"><span>{attrIcons.pHTolerance}</span>pHTolerance</span>
          <span className="font-bold text-gray-800">{pHTolerance}</span>
        </div>
        <div className="flex items-center justify-between w-full px-2">
          <span className="flex items-center gap-1 text-gray-600"><span>{attrIcons.Motility}</span>Motility</span>
          <span className="font-bold text-gray-800">{Motility}</span>
        </div>
      </div>
      <div className="text-xs text-gray-400 mb-1">Trait</div>
      <div className="flex items-center gap-2 mt-1">
        <span className="inline-flex items-center justify-center w-6 h-6 rounded bg-white border" style={{ background: traitColors[trait], color: '#fff' }}>{traitIcons[trait]}</span>
        <span className="text-sm font-medium text-gray-700">{trait}</span>
      </div>
    </div>
  );
}

export default function ForTheGramMicrobeCardsGrid() {
  return (
    <div className="w-full flex flex-wrap gap-4 md:gap-6 justify-center">
      {microbeData.map((microbe, idx) => (
        <MicrobeCard key={microbe.name} {...microbe} />
      ))}
    </div>
  );
} 